import styled from 'styled-components';

export const LoadingScreenContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme: { token } }) => token.colorBgLayout};
  height: 100%;
  width: 100%;

  .loading-content-container {
    z-index: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme: { token } }) => token.marginXL}px;
  }

  .loading-title {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading4}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .loading-description {
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    color: ${({ theme: { token } }) => token.colorTextDescription};
    width: 435px;
    text-align: center;
  }
`;
